import { Button, Grid, Stack, Typography } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import DialogChangePassword from 'components/Dialogs/ChangePassword'
import EditInput from 'components/EditInput'
import EditPrefecture from 'components/EditPrefecture'
import { useState } from 'react'

export default function Profile() {
  const loginUser = useAppSelector((s) => s.UI.auth)
  const [changePassword, setChangePassword] = useState(false)
  console.log(loginUser)
  if (!loginUser) return <h1>Loading...</h1>
  return (
    <>
      {changePassword && (
        <DialogChangePassword
          id={loginUser.id}
          handleClose={() => setChangePassword(false)}
        />
      )}
      <Grid container spacing={1} mt={2}>
        <Grid item xs={12}>
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ borderBottom: 2, pb: 1 }}
          >
            <Typography variant="h5" component="h2" fontWeight="bold">
              MY情報
            </Typography>
            <Button
              sx={{
                px: 4,
              }}
              size="small"
              variant="contained"
              color="warning"
              onClick={() => {
                setChangePassword(true)
              }}
            >
              <Typography>パスワード変更</Typography>
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack>
            <EditInput
              label="ニックネーム"
              value={loginUser.name}
              apiEndpoint={'/api/users/' + loginUser.id}
              fieldName="name"
            />
            <Stack
              my={2}
              direction="row"
              spacing={2}
              alignItems={{
                md: 'center',
                xs: 'flex-start',
              }}
            >
              <Typography fontWeight="bold" variant="body2" minWidth={60}>
                性別
              </Typography>
              <Stack direction="row" alignItems="center">
                <Typography>
                  {loginUser.sex === 'male' ? '男性' : '女性'}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              my={2}
              direction="row"
              spacing={2}
              alignItems={{
                md: 'center',
                xs: 'flex-start',
              }}
            >
              <Typography fontWeight="bold" variant="body2" minWidth={60}>
                誕生月
              </Typography>
              {/* <Stack direction="row" alignItems="center">
                <Typography>
                  {format(new Date(loginUser.birthday), 'yyyy年MM月')}
                </Typography>
              </Stack> */}
            </Stack>
            <EditPrefecture
              label="都道府県"
              prefectureId={loginUser.prefectureId}
              apiEndpoint={'/api/users/' + loginUser.id}
              fieldName="prefectureId"
            />
          </Stack>
        </Grid>
      </Grid>
    </>
  )
}
